import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILED,
    LOGOUT_USER,
    REGISTER_USER,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAILED,
    VERIFY_EMAIL,
    VERIFY_EMAIL_SUCCESS,
    VERIFY_EMAIL_FAILED,
    FORGET_PASSWORD,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAILED,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    CLEAR_AUTH_ERROR,
} from './constants';

export const loginUser = (username, password) => ({
    type: LOGIN_USER,
    payload: { username, password },
});

export const loginUserSuccess = (user) => ({
    type: LOGIN_USER_SUCCESS,
    payload: user,
});

export const loginUserFailed = (error) => ({
    type: LOGIN_USER_FAILED,
    payload: error,
});

export const registerUser = (fullname, email, password) => ({
    type: REGISTER_USER,
    payload: { fullname, email, password },
});

export const registerUserSuccess = (data) => ({
    type: REGISTER_USER_SUCCESS,
    payload: data,
});

export const registerUserFailed = (error) => ({
    type: REGISTER_USER_FAILED,
    payload: error,
});

export const verifyEmail = (email, code) => ({
    type: VERIFY_EMAIL,
    payload: { email, code },
});

export const verifyEmailSuccess = (user) => ({
    type: VERIFY_EMAIL_SUCCESS,
    payload: user,
});

export const verifyEmailFailed = (error) => ({
    type: VERIFY_EMAIL_FAILED,
    payload: error,
});

export const logoutUser = (history) => ({
    type: LOGOUT_USER,
    payload: { history },
});

export const forgetPassword = (email) => ({
    type: FORGET_PASSWORD,
    payload: { email },
});

export const forgetPasswordSuccess = (message) => ({
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
});

export const forgetPasswordFailed = (error) => ({
    type: FORGET_PASSWORD_FAILED,
    payload: error,
});

export const resetPassword = (email, code, newPassword) => ({
    type: RESET_PASSWORD,
    payload: { email, code, newPassword },
});

export const resetPasswordSuccess = (message) => ({
    type: RESET_PASSWORD_SUCCESS,
    payload: message,
});

export const resetPasswordFailed = (error) => ({
    type: RESET_PASSWORD_FAILED,
    payload: error,
});

export const clearAuthError = () => ({
    type: CLEAR_AUTH_ERROR,
});
